// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    background:black;
    /* background-color: #333; */
    color: white;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999;
    box-shadow: 0 4px 4px rgba(255, 255, 255, 0.3);
}

.link {
    color: white;
}

.hoverdrop{
    color:black;
   }
.hoverdrop:hover{
 color: #5E17EB;
}

.btn {
    padding: 0.7rem 1rem;
    border-radius: 5em;
    color: white;
    background-color: #5E17EB;
    box-sizing: border-box;
    font-family: 'Inter';
    font-weight: 500;
    font-size: 16px;
}

.menu {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.menu li {
    margin-right: 40px;
    font-weight: 500;
    font-family: sans-serif;
    font-size: 20px;
}

.menu-toggle {
    background: none;
    border: none;
    color: #fff;
    font-size: 16px;
    display: none;
    cursor: pointer;
    margin-top: 25px;
}

.menu-toggle span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: white;
    margin-bottom: 5px;
    margin-right: 10px;
}

.navbar-bg {
    background-color: #000;
    color: #fff;
}
.background-video-nav {
    position: relative;
    height: 60px;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.background-video-nav video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media (max-width: 1337px) {
    .navbar {
        padding-right: 0px;
        padding-left: 0px;
        align-items: flex-start;
        background-color: black;
        color: white;
    }

    .menu {
        flex-direction: column;
        align-items: flex-start;
        display: none;
        margin-top: 50px;
    }

    .menu.open {
        display: flex;
        margin-left: 20px;
        width: 100vw;
    }

    .menu li {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 10px;
    }

    .btn {
        display: none;
    }

    .menu-toggle {
        display: block;
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .navbar-bg {
        background-color: #fff;
        color: #000;
    }

    .link-bg {
        color: white;
    }

    .link-color {
        color: black;
    }
    .w-fullt{
        width:'100%'
    }
    .flex-wrapt{
        flex-wrap: wrap;
    }
}

@media (min-width:1338px) {
    .navbar-bg {
        background-color: #000;
        color: #fff;
    }

    .link-bg {
        color: #fff;
    }

    .link-color {
        color: black;
    }
}`, "",{"version":3,"sources":["webpack://./src/Home/header.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;GACZ;AACH;CACC,cAAc;AACf;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IAEI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IAKf,aAAa;IACb,eAAe;IACf,gBAAgB;AALpB;;AAQA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;QACjB,uBAAuB;QACvB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;IACA;QACI;IACJ;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".navbar {\n    background:black;\n    /* background-color: #333; */\n    color: white;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    padding: 10px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 999;\n    box-shadow: 0 4px 4px rgba(255, 255, 255, 0.3);\n}\n\n.link {\n    color: white;\n}\n\n.hoverdrop{\n    color:black;\n   }\n.hoverdrop:hover{\n color: #5E17EB;\n}\n\n.btn {\n    padding: 0.7rem 1rem;\n    border-radius: 5em;\n    color: white;\n    background-color: #5E17EB;\n    box-sizing: border-box;\n    font-family: 'Inter';\n    font-weight: 500;\n    font-size: 16px;\n}\n\n.menu {\n    display: flex;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n\n.menu li {\n    margin-right: 40px;\n    font-weight: 500;\n    font-family: sans-serif;\n    font-size: 20px;\n}\n\n.menu-toggle {\n    display: none;\n    background: none;\n    border: none;\n    color: #fff;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.menu-toggle {\n    display: none;\n    cursor: pointer;\n    margin-top: 25px;\n}\n\n.menu-toggle span {\n    display: block;\n    width: 25px;\n    height: 3px;\n    background-color: white;\n    margin-bottom: 5px;\n    margin-right: 10px;\n}\n\n.navbar-bg {\n    background-color: #000;\n    color: #fff;\n}\n.background-video-nav {\n    position: relative;\n    height: 60px;\n    width: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.background-video-nav video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n@media (max-width: 1337px) {\n    .navbar {\n        padding-right: 0px;\n        padding-left: 0px;\n        align-items: flex-start;\n        background-color: black;\n        color: white;\n    }\n\n    .menu {\n        flex-direction: column;\n        align-items: flex-start;\n        display: none;\n        margin-top: 50px;\n    }\n\n    .menu.open {\n        display: flex;\n        margin-left: 20px;\n        width: 100vw;\n    }\n\n    .menu li {\n        margin-left: 0;\n        margin-right: 0;\n        margin-bottom: 10px;\n    }\n\n    .btn {\n        display: none;\n    }\n\n    .menu-toggle {\n        display: block;\n        position: absolute;\n        right: 10px;\n        top: 10px;\n    }\n\n    .navbar-bg {\n        background-color: #fff;\n        color: #000;\n    }\n\n    .link-bg {\n        color: white;\n    }\n\n    .link-color {\n        color: black;\n    }\n    .w-fullt{\n        width:'100%'\n    }\n    .flex-wrapt{\n        flex-wrap: wrap;\n    }\n}\n\n@media (min-width:1338px) {\n    .navbar-bg {\n        background-color: #000;\n        color: #fff;\n    }\n\n    .link-bg {\n        color: #fff;\n    }\n\n    .link-color {\n        color: black;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
